<template lang="pug">
#fb_pixels_wrapper
  vue-tags-input(v-model="fb_pixel",:tags="fb_pixels",@tags-changed="tagChanged")
  button.mt-3.btn.btn-default(@click="update") 保存する
</template>

<script>

import { mapState } from 'vuex'

import Vue from 'vue'

import PrSetting from '../apis/pr_setting'

import VueTagsInput from '@johmun/vue-tags-input';

export default {
  data(){
    return {
      fb_pixels: [],
      fb_pixel: ""
    }
  },
  methods: {
    async init(){
      const { data } = await PrSetting.all()
      this.fb_pixels = data.map((fb_pixel) => {
        return {text: fb_pixel}
      })
    },
    async update(){
      console.log("update")
      await PrSetting.update({
        fb_pixels: this.fb_pixels.map(fb_pixel => fb_pixel.text).join(",")
      })

      this.$toasted.success('pixelを更新しました')
      await sleep(10000)
      this.$toasted.clear()
    },
    tagChanged(fb_pixels){
      this.fb_pixels = fb_pixels
    }
  },
  mounted(){
  },
  watch: {
  },
  async mounted(){
    await Vue.nextTick()
    await this.init()
  },
  components: {
    VueTagsInput
  },
}
</script>
